import { render, staticRenderFns } from "./teachermsg.vue?vue&type=template&id=320bd316&scoped=true&"
import script from "./teachermsg.vue?vue&type=script&lang=js&"
export * from "./teachermsg.vue?vue&type=script&lang=js&"
import style0 from "./teachermsg.vue?vue&type=style&index=0&id=320bd316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320bd316",
  null
  
)

export default component.exports